import React, { useCallback, useEffect, useMemo } from 'react';
import { Col, Form, Row, Select } from 'antd';

export interface IContractStepValues {
  virtualPlanId: number | undefined;
}

const formInitialValues = {
  virtualPlanId: undefined,
};

interface IContractStep {
  contractDetails: any;

  onChange: (values: IContractStepValues) => void | undefined;
  defaultContractId?: number;

  contractsByClient?: any[];
}

const ContractStep = ({
  contractDetails,
  onChange,
  defaultContractId,
  contractsByClient,
}: IContractStep) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (contractDetails) {
      form.setFieldsValue({ ...contractDetails });
    }
  }, [contractDetails, form]);

  const contractsByClientOptions = useMemo(
    () =>
      contractsByClient?.map(
        ({ id, planDesc }: { id: boolean; planDesc: string }) => ({
          label: planDesc,
          value: id,
        }),
      ),
    [contractsByClient],
  );
  const handleOnValuesChange = useCallback(
    (changedValue: any, values: any) => {
      onChange(values);
    },
    [onChange],
  );

  return (
    <Form
      form={form}
      onValuesChange={handleOnValuesChange}
      initialValues={formInitialValues}
      layout="vertical"
    >
      {!defaultContractId && (
        <Row gutter={[16, 16]} justify="center">
          <Col lg={16} xl={16} xs={24}>
            <Form.Item name="virtualPlanId" style={{ margin: 0 }}>
              <Select
                optionFilterProp="label"
                options={contractsByClientOptions}
                loading={!contractsByClientOptions}
                disabled={!contractsByClientOptions}
                showSearch
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default ContractStep;
